import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';

const states: Ng1StateDeclaration[] = [
    {
        name: 'standAlonePrintDashboard',
        url: '/print/:user/:password/:appName/:appEnv/:appModel/printDashboard/:guid?orientation&format&beginDate&endDate&groupGuid&isStorage&lang',
        params: {
            orientation: {
                type: 'int'
            },
            format: {
                type: 'int'
            },
            beginDate: {
                type: 'string'
            },
            endDate: {
                type: 'string'
            },
            groupGuid: {
                value: '',
                squash: true
            },
            isStorage: {
                type: 'string'
            },
            lang: {
                value: '',
                squash: true
            }
        },
        component: 'wtPrintDashboardState',
        resolve: {
            printing: ['$stateParams', ($stateParams) => $stateParams.isStorage],
            auth: ['$stateParams', '$q', 'configurationService', 'storeActionsService',
                ($stateParams, $q, configurationService, storeActionsService) => Resolve.standAlone($stateParams, $q, configurationService, storeActionsService)]
        },
        data: {
            visible: false,
            displayName: 'Print preview',
            editButtonVisibility: () => false,
        }
    }];

export default states;